import request from '@/utils/request'

// 续费套餐列表（启用中）+ 当前机构到期时间：POST
export function rechargePackageList() {
  return request.post('/recharge/packageList')
}

// 创建续费订单：POST package_id
export function rechargeOrder(packageId) {
  return request.post('/recharge/order', { package_id: packageId })
}

// 发起支付，返回支付二维码图：GET order_id paytype(wechat|alipay)
export function rechargePay(orderId, paytype) {
  return request.get('/recharge/pay', { params: { order_id: orderId, paytype } })
}

// 我的续费订单列表：GET status page limit
export function rechargeOrders(params) {
  return request.get('/recharge/myOrders', { params: params || {} })
}